import _ from 'underscore';
import anime from 'animejs';
import Emitter from 'event-emitter';
import 'scrolling-element'

class ScrollManager  {

  animating = false;
  _dirty = true;

  constructor() {
    Emitter(this);
    this.addEvents();
  }

  addEvents() {
    window.addEventListener('scroll', _.throttle(this.onScroll, 1000/4));
  }

  currentScroll = () => {
    if (!this._dirty) return this._scrollTop;
    this._dirty = false;
    return this._scrollTop = document.scrollingElement.scrollTop;
  } ;

  onScroll = () => {
    this._dirty = true;
    this.emit('scroll');
  };

  freeze = ()=> {
    document.scrollingElement.style.overflow = 'hidden';
  }

  unfreeze = ()=> {
    document.scrollingElement.style.overflow = 'auto';
  }

  scrollTo(target){
    const scrollTop = target.getBoundingClientRect().top + this.currentScroll();

    this.animating = true;

    anime({
      duration: 1200,
      targets: document.scrollingElement,
      scrollTop,
      easing: 'easeInOutQuart',
      complete : ()=> this.animating = false
    });
  }

}

export default new ScrollManager();



// WEBPACK FOOTER //
// ./src/components/manager/ScrollManager.js